export const ZOOM_FACTORS_PRESETS = [
  {
    labelKey: 'fitSize',
    factor: 'fit',
  },
  {
    labelKey: 'actualSize',
    factor: 1,
  },
  {
    label: '25%',
    factor: 0.25,
  },
  {
    label: '50%',
    factor: 0.5,
  },
  {
    label: '75%',
    factor: 0.75,
  },
  {
    label: '125%',
    factor: 1.25,
  },
  {
    label: '170%',
    factor: 1.7,
  },
  {
    label: '300%',
    factor: 3,
  },
  {
    label: '500%',
    factor: 5,
  },
  {
    label: '1000%',
    factor: 10,
  },
];
